import axios from "axios"
import webconfig from '../webconfig.json'
import { validaToken, getToken } from "../auth"

const apiETCE = axios.create({
  baseURL: webconfig.ApieTCE,
})

apiETCE.interceptors.request.use(async config => {
    const token = getToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      validaToken()
    }
    return config
})

export default apiETCE